<form [formGroup]="form" class="formgrid grid">
    <div class="field col-12">
      <label>Rufnummernmitnahme</label>
      <div class="flex flex-wrap gap-3 mb-3">
        <div class="flex align-items-center">
          <p-radioButton [value]="false" formControlName="porting" inputId="portingInputFalse"></p-radioButton>
          <label for="portingInputFalse" class="ml-2">Nein</label>
        </div>
        <div class="flex align-items-center">
          <p-radioButton [value]="true" formControlName="porting" inputId="portingInputTrue"></p-radioButton>
          <label for="portingInputTrue" class="ml-2">Ja, inkl. Kündigung des bisherigen Vertrages</label>
        </div>
      </div>
    </div>
    <ng-container *ngIf="showFields()">
      <div class="field col-12 md:col-3">
        <label for="number1Input"
          >1. Rufnummer<ow-validation-mark [control]="form.controls.number1"></ow-validation-mark
        ></label>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            06831
          </span>
          <input type="text" pInputText id="number1Input" formControlName="number1" class="w-full" />
        </div>
      </div>
      <div class="field col-12 md:col-3" *ngIf="numbersCount() >= 2">
        <label for="number2Input"
          >2. Rufnummer<ow-validation-mark [control]="form.controls.number2"></ow-validation-mark
        ></label>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            06831
          </span>
          <input type="text" pInputText id="number2Input" formControlName="number2" class="w-full" />
        </div>
      </div>
      <div class="field col-12 md:col-3" *ngIf="numbersCount() >= 3">
        <label for="number3Input"
          >3. Rufnummer<ow-validation-mark [control]="form.controls.number3"></ow-validation-mark
        ></label>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            06831
          </span>
          <input type="text" pInputText id="number3Input" formControlName="number3" class="w-full" />
        </div>
      </div>
      <div class="field col-12 md:col-3" *ngIf="numbersCount() >= 4">
        <label for="number4Input"
          >4. Rufnummer<ow-validation-mark [control]="form.controls.number4"></ow-validation-mark
        ></label>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            06831
          </span>
          <input type="text" pInputText id="number4Input" formControlName="number4" class="w-full" />
        </div>
      </div>
      <div class="field col-12 md:col-3" *ngIf="numbersCount() >= 5">
        <label for="number5Input"
          >5. Rufnummer<ow-validation-mark [control]="form.controls.number5"></ow-validation-mark
        ></label>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            06831
          </span>
          <input type="text" pInputText id="number5Input" formControlName="number5" class="w-full" />
        </div>
      </div>
      <div class="field col-12 md:col-3" *ngIf="numbersCount() >= 6">
        <label for="number6Input"
          >6. Rufnummer<ow-validation-mark [control]="form.controls.number6"></ow-validation-mark
        ></label>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            06831
          </span>
          <input type="text" pInputText id="number6Input" formControlName="number6" class="w-full" />
        </div>
      </div>
      <div class="field col-12 md:col-3" *ngIf="numbersCount() >= 7">
        <label for="number7Input"
          >7. Rufnummer<ow-validation-mark [control]="form.controls.number7"></ow-validation-mark
        ></label>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            06831
          </span>
          <input type="text" pInputText id="number7Input" formControlName="number7" class="w-full" />
        </div>
      </div>
      <div class="field col-12 md:col-3" *ngIf="numbersCount() >= 8">
        <label for="number8Input"
          >8. Rufnummer<ow-validation-mark [control]="form.controls.number8"></ow-validation-mark
        ></label>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            06831
          </span>
          <input type="text" pInputText id="number8Input" formControlName="number8" class="w-full" />
        </div>
      </div>
      <div class="field col-12 md:col-3" *ngIf="numbersCount() >= 9">
        <label for="number9Input"
          >9. Rufnummer<ow-validation-mark [control]="form.controls.number9"></ow-validation-mark
        ></label>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            06831
          </span>
          <input type="text" pInputText id="number9Input" formControlName="number9" class="w-full" />
        </div>
      </div>
      <div class="field col-12 md:col-3" *ngIf="numbersCount() >= 10">
        <label for="number10Input"
          >10. Rufnummer<ow-validation-mark [control]="form.controls.number10"></ow-validation-mark
        ></label>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            06831
          </span>
          <input type="text" pInputText id="number10Input" formControlName="number10" class="w-full" />
        </div>
      </div>
      <div class="field col-12 md:col-3">
        <label>&nbsp;</label>
        <button
          type="button"
          pButton
          label="Rufnummer hinzufügen"
          icon="fa-solid fa-plus"
          (click)="addNumber()"
          [disabled]="numbersCount() >= 10"
          class="w-full p-button-success"
        ></button>
      </div>
      <div class="field col-12 md:col-3">
        <label>&nbsp;</label>
        <button
          type="button"
          pButton
          label="Rufnummer entfernen"
          icon="fa-solid fa-plus"
          (click)="remNumber()"
          [disabled]="numbersCount() <= 1"
          class="w-full p-button-danger"
        ></button>
      </div>
      <div class="field col-12">
        <label for="providerInput"
          >Aktueller Anbieter<ow-validation-mark [control]="form.controls.provider"></ow-validation-mark
        ></label>
        <p-dropdown
          inputId="providerInput"
          formControlName="provider"
          [options]="PROVIDER_OPTIONS"
          [filter]="true"
          placeholder="Bitte wählen"
          styleClass="w-full"
        ></p-dropdown>
      </div>
    </ng-container>
  </form>
  